import { Table, TableBody, TableRow } from '@material-ui/core'

import { bytesToUnitString } from '@/pages/demands/utils/string-conversions'
import { CultureLabel } from '@/types/culture'
import { ImageTypeLabel } from '@/types/image-types'
import { TreatmentLabel } from '@/types/treatment'
import { transformUnderscoreInSpaceAndUppercaseFirstLetter } from '@/utils/format-strings'

import { IDemandResume } from '../../types'
import AccordionPolygons from '../accordion'
import TableCellWithLabel from '../table-cell-wIth-label'
import { useStyles } from './style'

interface DemandResumeProps {
  formData: IDemandResume
}

const DemandResume = ({ formData }: DemandResumeProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Table className={classes.table}>
        <TableBody className={classes.body}>
          <TableRow className={classes.row}>
            <TableCellWithLabel name={'Nome do diagnóstico'} />
            <TableCellWithLabel value={formData.demand_name} withoutName />
          </TableRow>

          <TableRow className={classes.row}>
            <TableCellWithLabel name={'Diagnósticos'} />
            <TableCellWithLabel
              value={TreatmentLabel[formData.treatment]}
              withoutName
            />
          </TableRow>

          <TableRow className={classes.row}>
            <TableCellWithLabel
              name={'Cultura'}
              value={CultureLabel[formData.culture]}
            />
            <TableCellWithLabel name={'Responsável'} value={formData.sponsor} />
          </TableRow>

          <TableRow className={classes.row}>
            <TableCellWithLabel name={'Projeto'} value={formData.project} />
            <TableCellWithLabel name={'Região'} value={formData.region} />
          </TableRow>
          {formData.polygons && (
            <TableRow className={classes.accordionRow}>
              <AccordionPolygons value={formData.polygons} />
            </TableRow>
          )}
          <TableRow className={classes.row}>
            <TableCellWithLabel
              name={'Área a ser analisada aprox.'}
              value={`${Number(formData.area).toFixed(3)} ha`}
            />
            <TableCellWithLabel
              name={'Data do voo'}
              value={new Date(formData.flight_date).toLocaleDateString(
                'pt-BR',
                {
                  timeZone: 'UTC',
                },
              )}
            />
          </TableRow>

          {formData.planting_type &&
            formData.planting_space &&
            formData.cane_cycle_type && (
              <TableRow className={classes.row}>
                <TableCellWithLabel
                  name={'Tipo de plantio'}
                  value={transformUnderscoreInSpaceAndUppercaseFirstLetter(
                    formData.planting_type,
                  )}
                />
                <TableCellWithLabel
                  name={'Distância entre plantas'}
                  value={`${formData.planting_space} cm`}
                />
                <TableCellWithLabel
                  name={'Tipo de ciclo'}
                  value={transformUnderscoreInSpaceAndUppercaseFirstLetter(
                    formData.cane_cycle_type,
                  )}
                />
              </TableRow>
            )}

          <TableRow className={classes.row}>
            <TableCellWithLabel
              name={'Tipo de Imagem'}
              value={ImageTypeLabel[formData.image_type]}
            />
            <TableCellWithLabel
              name={'Tamanho da(s) imagem(s)'}
              value={bytesToUnitString(formData.image_size)}
            />
          </TableRow>

          {['raw_images', 'raw_images_geotag'].includes(
            formData.image_type,
          ) && (
            <TableRow className={classes.row}>
              <TableCellWithLabel
                name={'Quantidade de imagens'}
                value={formData.image_count}
              />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  )
}

export default DemandResume
